import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Article from '../templates/Article'

const Page = props => {
  return (
    <Article pathName={props.location.pathname} pageTitle="Home">
      <StyledIndex>
        <h1>Educational Technology M.Ed.</h1>
        <h2>University of Florida</h2>
        <p>Phil Sinatra</p>
      </StyledIndex>
    </Article>
  )
}

Page.propTypes = {
  location: PropTypes.object,
}

const StyledIndex = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  padding: 0 1.5rem;

  h1,
  h2 {
    font-weight: 300;
    margin: 0 0 0.5rem;
    text-align: center;
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 700;
  }

  p {
    font-size: 0.89rem;
  }

  p {
    margin: 0;
  }
`

export default Page
